import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";

const SqEnroll = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col h-screen bg-gray-50">
      {/* Header */}
      <div className="fixed top-0 left-0 w-full z-50 bg-primary">
        <Header />
      </div>

      {/* Main Layout */}
      <div className="flex flex-1 mt-[72px]">
        {/* Sidebar */}
        <div className="fixed left-0 w-64 bg-white shadow-sm h-[calc(100vh-72px)] overflow-y-auto hidden lg:block">
          <Sidebar />
        </div>

        {/* Main Content */}
        <main className="flex-1 p-6 overflow-y-auto mt-[25px] lg:ml-64">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
              {/* Heading */}
              <h1 className="text-3xl font-bold text-gray-800 mb-6 border-b pb-4">
                Suquamish Tribal Enrollment Office
              </h1>

              {/* Content */}
              <div className="space-y-6 text-gray-700">
                <p>
                  The Suquamish Tribal Enrollment Office processes enrollment applications for membership in the Suquamish Tribe. It also handles lineage testing for Enrollment, as well as licensing qualified Tribal members for salmon or shellfish harvesting activities, as guaranteed by the Point Elliot Treaty of 1855.
                </p>
                
                <p>
                  The office is responsible for all data pertaining to the enrollment of an individual into the Tribe. They work closely with outside agencies to obtain the information required for enrollment.
                </p>

                {/* Button */}
                <div className="pt-4">
                  <a 
                    href="https://suquamish.nsn.us" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-block px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors font-medium"
                  >
                    Visit Our Website
                  </a>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="mt-8 text-center text-gray-500 text-sm">
              <p>© {new Date().getFullYear()} Suquamish Tribe. All rights reserved.</p>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default SqEnroll;